export interface SortableItem {
	id: string;
	name: string;
	//for sorting/moving
	fromList?: string;
	index?: number;
	preview?: boolean;
}


export function useSortableItem() {
	
	function previewItem(): SortableItem {
		return {id:"0", name: "", preview: true};
	}
	
	return {previewItem};
}